import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MediaType } from "@front/m19-api-client";
import { isVideo } from "@m19-board/shared/media/media.utils";

@Component({
  selector: "app-media",
  imports: [],
  template: `@if (!isVideo()) {
      <img [src]="mediaSource()" class="max-h-full" />
    } @else {
      <video controls autoplay [muted]="true" loop [src]="mediaSource()" class="max-h-full"></video>
    }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaComponent {
  mediaSource = input.required<string>();
  mediaType = input.required<MediaType>();

  isVideo = computed(() => isVideo(this.mediaType()));
}
